import React, { useState } from 'react';
import { Button, IconButton, Typography } from '@mui/material';
import { Toolbar } from 'components';
import { Person } from '@mui/icons-material';
import styled from 'styled-components';

const TrainerToolbar = ({
	totalSelected,
	selectedIds,
	selected,
	handleClear
}) => (
	<Toolbar open={selectedIds?.length > 0} handleClose={handleClear}></Toolbar>
);

export default TrainerToolbar;

const StyledButton = styled(Button)`
	margin-right: 10px;
`;
